import { N05_02 } from "./N05_02";

export const N05_01 = {
  selectedValueColumn: "ItemCode",
  selectedTitle: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Region",
        binding: {
          data: {
            columns: [
              {
                name: "Region",
                columnName: "RegionName",
                width: "450px",
                align: "left",
                sortable: true,
              },
              {
                name: "Number Of Branches",
                columnName: "NumberOfBranches",
                width: "350px",
                align: "center",
                sortable: true,
              },
            ],
            title: "RegionName",
            endpoint: "SFE_N05.1",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "ItemCode", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N05_02,
            },
          },
        },
      },
    },
  ],
};
